import CalendarIcon from '@material-ui/icons/CalendarToday';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import ListAltIcon from '@material-ui/icons/ListAlt';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';

// These basic route definitions are extended with components in Router.jsx
export const ROUTE_DEFINITIONS = {
  transaction: {
    path: '/transaction',
    i18nKey: 'transaction',
    icon: AccountBalanceIcon,
  },
  inventory: {
    path: '/inventory',
    i18nKey: 'inventory',
    icon: ListAltIcon,
  },
  reports: {
    path: '/reports',
    i18nKey: 'reports',
    icon: AssessmentOutlinedIcon,
  },
  appointments: {
    path: '/appointments',
    i18nKey: 'appointments',
    icon: CalendarIcon,
  },
  profile: {
    path: '/profile',
    i18nKey: 'profile',
    icon: PermIdentityIcon,
  },
  maintenance: {
    path: '/maintenance',
    i18nKey: 'maintenance',
  },
};
